import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { Config } from '@nw/shared/config';
import { getAPIErrorResponse } from '@nw/shared/utils';

const useGetInitialProductConfig = (): {
  getInitialConfigAPI: UseMutateAsyncFunction<
    any,
    unknown,
    {
      productCode: string;
    },
    unknown
  >;
  error: string;
  status: MutationStatus;
} => {
  //TODO: change beta in the url to the environment variable
  const getWebinarProductConfigData = async ({ productCode }) => {
    const uniqueId = Date.now();
    return await fetch(
      `https://nw-payments-backend-media-static.s3.ap-south-1.amazonaws.com/${Config['ENVIRONMENT']}/product_configs/${productCode}.json?time=${uniqueId}`
    ).then((res) => res.json());
  };

  const { mutateAsync, error, status } = useMutation(
    getWebinarProductConfigData,
    {
      retry: 3,
      retryDelay: (attempt) =>
        Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 20 * 1000)
    }
  );

  const getInitialConfigAPI = mutateAsync;
  return {
    getInitialConfigAPI,
    status,
    error: error ? getAPIErrorResponse(error) : ''
  };
};

export { useGetInitialProductConfig };
